import React from 'react'
import { Link } from 'react-router-dom';
import {AiOutlineInstagram  , AiFillYoutube} from "react-icons/ai";
import {BiLogoDiscordAlt} from "react-icons/bi";
import {FaTwitter} from "react-icons/fa";
const Fotter = () => {
  return (
    <footer className="relative bg-black text-white pt-8 pb-6">
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap text-left lg:text-left">
        <div className="w-full lg:w-6/12 px-4">
          <h4 className="text-3xl font-semibold">Let's keep in touch!</h4>
          <h5 className="text-lg mt-0 mb-2">
            Find us on any of these platforms, we respond 1-2 business days.
          </h5>
         
             <div className="mt-6 lg:mb-0 mb-3 flex">
             <div className="bg-white rounded-full p-2 mr-2">
  <a
    href="https://twitter.com/ANTECH262563"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-400 hover:text-blue-500"
  >
    <FaTwitter size={20} />
  </a>
</div>
        <div className="bg-white rounded-full p-2 mr-2">
          <a
            href="https://www.instagram.com/_antech2/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-pink-400 hover:text-pink-500"
          >
            <AiOutlineInstagram size={20} />
          </a>
        </div>
        <div className="bg-white rounded-full p-2 mr-2">
          <a
            href="https://youtube.com/channel/UCq_LkXOs1VYpIdfxOi-6PMA"
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-400 hover:text-red-500"
          >
            <AiFillYoutube size={20} />
          </a>
        </div>
        <div className="bg-white rounded-full p-2">
          <a
            href="https://discord.gg/5x6AgqQe"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-500"
          >
            <BiLogoDiscordAlt size={20} />
          </a>
        </div>
      </div>
        </div>
        <div className="w-full lg:w-6/12 px-4">
          <div className="flex flex-wrap items-top mb-6">
            <div className="w-full lg:w-4/12 px-4 ml-auto">
              <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">Useful Links</span>
              <ul className="list-unstyled">
                <li>
                  <Link to='/about' className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm">About Us</Link>
                </li>
                <li>
                  <Link to='/' className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm">Home</Link>
                </li>
                <li>
                  <Link to='/projects' className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm">Project</Link>
                </li>
                <li>
                  <a className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm" href="https://drive.google.com/file/d/1WxycuK5QHWSWF_J9f4sBKxXuzhThqTW7/view">BROCHURE</a>
                </li>
              </ul>
            </div>
            <div className="w-full lg:w-4/12 px-4">
              <span className="block uppercase text-blueGray-500 text-sm font-semibold mb-2">Other Resources</span>
              <ul className="list-unstyled">
               
                <li>
                  <Link to='/termsandcondition' className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm">Terms &amp; Conditions</Link>
                </li>
                <li>
                  <Link to='/privacypolicy' className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm">Privacy Policy</Link>
                </li>
                <li>
                  <Link to='/contact' className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm">Contact Us</Link>
                </li>
                <li>
                  <a className="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm" href='https://docs.google.com/forms/d/1yjarUlpExfa4oIXJfskZ9iVP1LB8tntja9nDG6Ip_n8/viewform?edit_requested=true'>Work with us</a>
                  </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <hr className="my-6 border-blueGray-300" />
      <div className="flex flex-wrap items-center md:justify-between justify-center">
        <div className="w-full md:w-4/12 px-4 mx-auto text-center">
          <div className="text-sm text-blueGray-500 font-semibold py-1">
            Copyright © <span id="get-current-year">2023</span>
            <a href='/' className="text-blueGray-500 hover:text-gray-800" target="_blank" /> AN-TECH by
            <a href="/" className="text-blueGray-500 hover:text-blueGray-800">AN-TECH team</a>.
          </div>
        </div>
      </div>
    </div>
  </footer>

  )
}

export default Fotter